import {List} from 'immutable';

import * as TaskRunner from 'util/TaskRunner';

import {ValidationReportType} from './TenantComparisonConstants';

export function exportValidationReportConfigs(
  validationReportType: ValidationReportType
): Promise<{exportUrl: string}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/validation-report:export-configs',
    data: {validationReportType},
  });
}

export interface DiffValidationReportConfigsParams {
  sourceConfigsUrl: string;
  targetConfigsUrl: string | null;
  diffType: string | null;
  matchOverrides: List<List<string>> | null;
}

export function diffValidationReportConfigs(
  validationReportType: ValidationReportType,
  params: DiffValidationReportConfigsParams
): Promise<{reportUrl: string}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/validation-report:generate',
    data: {
      validationReportType,
      ...params,
    },
  });
}

export function getTenantComparisonURL(): string {
  return '/tools/tenant-comparison';
}

// Keep in sync with benchling/config_migration/tenant_diff/constants.py
export interface TenantComparisonMetadata {
  tenantSubdomain: string;
  timestamp: string;
}

export function loadMetadata(exportUrl: string): Promise<TenantComparisonMetadata> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/validation-report:load-metadata',
    data: {sourceConfigsUrl: exportUrl},
  });
}
